exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ":root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n.BugsModal-module__closeBtn__3g8vZ {\n  position: absolute;\n  right: 10px;\n  z-index: 3;\n}\n.BugsModal-module__root__2yJWj {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.BugsModal-module__title__SUcZB {\n  width: 100%;\n  margin-bottom: 20px;\n  text-align: center;\n}\n.BugsModal-module__createBugBtn__11xGs svg {\n  margin-right: 5px;\n}\n.BugsModal-module__content__1nA0S {\n  width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"closeBtn": "BugsModal-module__closeBtn__3g8vZ",
	"root": "BugsModal-module__root__2yJWj",
	"title": "BugsModal-module__title__SUcZB",
	"createBugBtn": "BugsModal-module__createBugBtn__11xGs",
	"content": "BugsModal-module__content__1nA0S"
};